module.exports = __webpack_public_path__ + "img/profile-woman-13-min.30f35bfa.jpg";